import React from "react";
import { useTranslation } from "react-i18next";
import ScrollToTopLink from "../ScrollToTopLink";

const Menu = ({ data, submenu, handleSubmenuItemTouch, onItemClick }) => {
  const { t } = useTranslation();
  const submenuData = data[submenu] || [];

  const handleClick = (e) => {
    if (typeof onItemClick === "function") {
      onItemClick(e);
    }
    if (typeof handleSubmenuItemTouch === "function") {
      handleSubmenuItemTouch(e);
    }
  };

  return (
    <>
      {submenuData.map(({ name, to, id }) => (
        <li key={id}>
          <ScrollToTopLink
            onClick={handleClick}
            className={submenu === "footer" ? "" : "dropdown-item"}
            to={to}
          >
            {t(`nav.${name}`)}
          </ScrollToTopLink>
        </li>
      ))}
    </>
  );
};

export default Menu;
